import React from "react";
import { Field } from "formik";
import { formikPropTypes } from "components/common";
import DeploymentAutocompleteSelect from "./deployment-autocomplete-select";

const ValidatedDeploymentAutocompleteSelector = ({ field: { name, value, onChange, onBlur }, ...props }) => (
  <DeploymentAutocompleteSelect name={name} value={value} onChange={onChange} {...props} />
);

ValidatedDeploymentAutocompleteSelector.propTypes = {
  ...formikPropTypes,
  ...DeploymentAutocompleteSelect.propTypes,
};

const DeploymentAutocompleteSelectForm = ({ onChange, value, name, ...props }) => (
  <Field
    component={ValidatedDeploymentAutocompleteSelector}
    field={{
      name,
      onChange,
      value,
    }}
    {...props}
  />
);

DeploymentAutocompleteSelectForm.propTypes = {
  ...DeploymentAutocompleteSelect.propTypes,
};

export default DeploymentAutocompleteSelectForm;
